import { render, staticRenderFns } from "./AppDetailTab3-third.vue?vue&type=template&id=46b62808&scoped=true";
import script from "./AppDetailTab3-third.vue?vue&type=script&lang=js";
export * from "./AppDetailTab3-third.vue?vue&type=script&lang=js";
import style0 from "./AppDetailTab3-third.vue?vue&type=style&index=0&id=46b62808&prod&lang=less&scoped=true";

/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js";
var component = normalizer(script, render, staticRenderFns, false, null, "46b62808", null);
export default component.exports;